export enum VerificationType {
  MOBILE = 'mobile',
  NRIC = 'nric'
}

export enum VolunteerType {
  Individual = 'Individual',
  Org = 'Org'
}

export interface Organization {
  id: string;
  name: string;
}

export interface ActivityAttendance {
  activityId: string;
  activityName: string;
  activityStartTime: number; // Unix timestamp in milliseconds
  activityEndTime: number; // Unix timestamp in milliseconds
  attendanceStatus: 'NOT_ATTENDED' | 'ATTENDED' | 'ATTENDING';
}

export enum CheckInCheckOutEnrollmentStatus {
  ENROLLED = 'ENROLLED',
  NOT_ENROLLED = 'NOT_ENROLLED'
}

export enum CheckInCheckOutActivityType {
  INDIVIDUAL = 'INDIVIDUAL',
  ORGANIZATION = 'ORGANIZATION'
}

export enum CheckInCheckOutActionType {
  CHECK_IN = 'CHECK_IN',
  CHECK_OUT = 'CHECK_OUT'
}

export enum AttendanceStatus {
  NOT_ATTENDED = 'NOT_ATTENDED',
  ATTENDING = 'ATTENDING',
  ATTENDED = 'ATTENDED'
}

export enum CheckInCheckOutStep {
  NULL = 'NULL',
  SELECT_INDIVIDUAL_OR_ORG = 'SELECT_INDIVIDUAL_OR_ORG',
  SELECT_ORG = 'SELECT_ORG',
  VALIDATION_PROFILE = 'VALIDATION_PROFILE',
  RETRY_VALIDATION_PROFILE = 'RETRY_VALIDATION_PROFILE',
  EVENT_SELECTION = 'EVENT_SELECTION',
  TO_CHECK_IN = 'TO_CHECK_IN',
  TO_CHECK_OUT = 'TO_CHECK_OUT',
  CHECK_OUT_SUCCESS = 'CHECK_OUT_SUCCESS'
}

export interface IndividualValidationResponse {
  activityId: string;
  volunteerId: string;
  mobileNumber: string;
  activityName: string;
  centerName: string;
  activityStartTime: number;
  activityEndTime: number;
  activityType: CheckInCheckOutActivityType;
  enrollmentStatus: CheckInCheckOutEnrollmentStatus;
  attendanceStatus: AttendanceStatus;
  attendanceStatusTime?: number;
  volunteerName: string;
  attendanceRecordList: ActivityAttendance[];
}

export interface VolunteerData {
  volunteerId: string;
  mobileNumber: string;
  volunteerName: string;
}

export interface IndividualCheckInCheckOutResponse {
  activityId: string;
  volunteerId: string;
  attendanceAction: CheckInCheckOutActionType;
  attendanceStatus: AttendanceStatus;
  attendanceStatusTime?: number;
  checkInTime: number;
  checkOutTime: number | null;
}

export interface CheckInCheckOutCenterState {
  loading: boolean;
  step: CheckInCheckOutStep;
  volunteerData?: VolunteerData;
  individualCheckInCheckOut?: IndividualCheckInCheckOutResponse;
  showSomethingWentWrong?: boolean;
  attendanceStatusTime?: number;
  verificationType?: VerificationType;
  nric?: string;
  phone?: string;
  countryCode?: string;
  eventList: ActivityAttendance[];
  selectedEvent?: ActivityAttendance;
  centerName?: string;
  selectedVolunteerType?: VolunteerType;
  organizations: Organization[];
  selectedOrganization?: Organization;
}
